// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"61aef6ca","46":"a4835d7a","157":"b78876bb","532":"aca05b4a","563":"c03bd44d","810":"21017ce6"}[chunkId] + ".js";
};